import * as e from "react";
import { forwardRef as C } from "react";
const a = C(
  function(L, t) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: t,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...L
      },
      /* @__PURE__ */ e.createElement("circle", { cx: 12.0357, cy: 6.03571, fill: "#FFCA00", r: 2.03571 }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12.5 15L11.5 17.5L9 20M12.5 15L15.0108 16.6739C15.3229 16.8819 15.535 17.2099 15.5967 17.58L16 20M12.5 15V10.5C12.5 10.2239 12.2761 10 12 10H8.91421C8.649 10 8.39464 9.89464 8.20711 9.70711L7 8.5",
          stroke: "#FFCA00",
          strokeLinecap: "round",
          strokeWidth: 2.03571
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M19.3202 8.59625C19.6514 8.14205 19.5517 7.50534 19.0975 7.17411C18.6433 6.84288 18.0066 6.94257 17.6754 7.39677L19.3202 8.59625ZM15.0003 9.30392L13.9824 9.30589L13.9863 11.3416L15.0042 11.3396L15.0003 9.30392ZM16.8793 10.2158L16.0569 9.61611L16.8793 10.2158ZM16.6778 10.3185L16.6798 11.3364L16.6778 10.3185ZM16.8793 10.2158L17.7017 10.8156L19.3202 8.59625L18.4978 7.99651L17.6754 7.39677L16.0569 9.61611L16.8793 10.2158ZM16.6778 10.3185L16.6758 9.30069L15.0003 9.30392L15.0022 10.3218L15.0042 11.3396L16.6798 11.3364L16.6778 10.3185ZM16.8793 10.2158L16.0569 9.61611C16.2011 9.41832 16.431 9.30116 16.6758 9.30069L16.6778 10.3185L16.6798 11.3364C17.0839 11.3356 17.4635 11.1422 17.7017 10.8156L16.8793 10.2158Z",
          fill: "#FFCA00"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M4.9879 7.34851C4.83318 7.1033 5.07583 5.85311 5.98592 5.27888C6.896 4.70465 8.06698 4.92576 8.28359 5.26906C8.5002 5.61236 8.19566 6.76447 7.28557 7.33869C6.7448 7.6799 6.09006 7.70566 5.61526 7.61894L5.5471 7.60546C5.25758 7.54382 5.0462 7.44091 4.9879 7.34851Z",
          fill: "#815337",
          stroke: "#815337",
          strokeWidth: 0.626807
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M7.95231 6.10612C7.75719 5.95804 7.62633 5.83397 7.55857 5.72667C7.49084 5.61932 7.43432 5.44771 7.38463 5.20771C7.3705 5.13941 7.41532 5.07203 7.48362 5.05789C7.55172 5.04412 7.61838 5.08855 7.63248 5.15666L7.65018 5.23776L7.66843 5.31198C7.70213 5.4419 7.73728 5.53627 7.77232 5.5918C7.80739 5.6473 7.87661 5.7196 7.97921 5.80583L8.03929 5.85447C8.06005 5.87098 8.08195 5.88795 8.10488 5.90535C8.1604 5.94751 8.17111 6.02647 8.12898 6.08202C8.08682 6.13758 8.00787 6.14829 7.95231 6.10612ZM5.7883 7.55889C5.72002 7.573 5.65336 7.52936 5.63922 7.46108C5.59521 7.24845 5.54714 7.10171 5.49938 7.02594C5.45162 6.95024 5.33977 6.84365 5.16683 6.71239C5.11142 6.67034 5.10001 6.59104 5.14177 6.53551C5.18393 6.47995 5.26404 6.4685 5.3196 6.51066C5.51485 6.65883 5.64539 6.78372 5.71313 6.89107C5.78081 6.99842 5.83646 7.16995 5.88611 7.40981C5.90025 7.47811 5.8566 7.54476 5.7883 7.55889Z",
          fill: "#815337"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M5.911 6.76624C5.87644 6.71147 5.88919 6.64031 5.93842 6.60062L5.95042 6.59205L7.18631 5.81225C7.24529 5.77503 7.32328 5.79268 7.3605 5.85167C7.39506 5.90644 7.38231 5.9776 7.33309 6.01728L7.32109 6.02586L6.0852 6.80566C6.02621 6.84288 5.94822 6.82523 5.911 6.76624Z",
          fill: "#815337"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M5.98701 6.43021C5.94979 6.37122 5.96744 6.29323 6.02642 6.25601C6.0812 6.22145 6.15236 6.2342 6.19204 6.28343L6.20062 6.29543L6.46055 6.70739C6.49777 6.76638 6.48012 6.84437 6.42114 6.88158C6.36636 6.91614 6.2952 6.9034 6.25552 6.85417L6.24694 6.84217L5.98701 6.43021Z",
          fill: "#815337"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M6.39897 6.1702C6.36175 6.11121 6.37939 6.03322 6.43838 5.996C6.49315 5.96144 6.56431 5.97419 6.604 6.02342L6.61258 6.03542L6.87251 6.44738C6.90973 6.50637 6.89208 6.58436 6.83309 6.62158C6.77832 6.65613 6.70716 6.64339 6.66748 6.59416L6.6589 6.58216L6.39897 6.1702Z",
          fill: "#815337"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M6.48042 5.82694C6.4432 5.76795 6.46085 5.68996 6.51983 5.65274C6.57461 5.61818 6.64576 5.63093 6.68545 5.68015L6.69403 5.69216L6.95396 6.10412C6.99118 6.16311 6.97353 6.2411 6.91454 6.27831C6.85977 6.31287 6.78861 6.30013 6.74893 6.2509L6.74035 6.2389L6.48042 5.82694Z",
          fill: "#815337"
        }
      )
    );
  }
);
export {
  a as BetBuilderBadgeAmericanPassingActive
};
